import React from "react";
import PropTypes from "prop-types";

const DataRow = ({ title, primaryValue, secondaryValue, isFirstRow }) => {
  return (
    <div className="flex row">
      <div className={`b-1-3 row-padding data-text ${isFirstRow ? "first-column" : ""}`}>
        {title}
      </div>
      <div className={`b-1-3 row-padding border-right data-text ${isFirstRow ? "first-row" : ""}`}>
         {primaryValue}
      </div>
      <div className={`b-1-3 row-padding data-text ${isFirstRow ? "first-row" : ""}`}>
        {secondaryValue}
      </div>
    </div>
  );
};

DataRow.propTypes = {
  title: PropTypes.node,
  primaryValue: PropTypes.node,
  secondaryValue: PropTypes.node,
  isFirstRow: PropTypes.bool,
};

export default DataRow;
